import store from "../store/store";

/*
 * @Description  : 工具函数js
 * @Version      : 1.0
 * @Author       : lt
 * @Date         : 2021-12-28 11:06:52
 * @LastEditors: cwl
 * @LastEditTime: 2023-12-18 14:27:15
 */
const ls = window.localStorage;
const ss = window.sessionStorage;

export const createIframeHandleToken = function(type, url, fn) {
    let token = store.state.token;
    const iframe = document.createElement("iframe");
    iframe.src = url + "?fromExternal=1";
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    iframe.onload = function() {
        iframe.contentWindow.postMessage(
            JSON.stringify({
                type: type.toLocaleUpperCase(),
                token: token
            }),
            url
        );
        if (type.toLocaleUpperCase() === "GET") {
            setTimeout(() => {
                fn && fn();
            }, 500);
        }
    };
};
export const goSso = function(returnUrl, ssoBaseUrl, inOrOut = 0) {
    // 删除对应query参数 防止再次请求sso页时把上次的参数又给返回来
    let resKeyArr = ["isSuccess", "isPersonal", "token", "msg", "inOrOut"];
    resKeyArr.forEach(e => {
        returnUrl.indexOf(e) !== -1 &&
            (returnUrl = returnUrl.slice(0, returnUrl.indexOf(e) - 1));
    });
    const handledReturnUrl = returnUrl
        .replace(/#/g, "%23")
        .replace(/&/g, "/and/");
    window.location.href = `${ssoBaseUrl}?returnUrl=${handledReturnUrl}&inOrOut=${inOrOut}`;
};
export const Cookie = {
    set(name, value, expiredays) {
        let exdate = new Date();
        exdate.setDate(exdate.getDate() + expiredays);
        document.cookie =
            name +
            "=" +
            escape(value) +
            (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
    },
    get(name) {
        let arr;
        let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if ((arr = document.cookie.match(reg))) return arr[2];
        else return null;
    },
    remove(name) {
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);
        let cval = this.get(name);
        if (cval != null)
            document.cookie =
                name + "=" + cval + ";expires=" + exp.toGMTString();
    }
};

export const Local = {
    // 判断浏览器是否支持LocalStorage
    hasLocalStorage: function() {
        return (
            window.Storage &&
            window.localStorage &&
            window.localStorage instanceof Storage
        );
    },
    get(key) {
        if (this.hasLocalStorage()) {
            if (key) return JSON.parse(ls.getItem(key));
            return null;
        } else {
            return Cookie.get(key);
        }
    },
    set(key, val, day) {
        if (this.hasLocalStorage()) {
            const setting = arguments[0];
            if (
                Object.prototype.toString.call(setting).slice(8, -1) ===
                "Object"
            ) {
                for (const i in setting) {
                    ls.setItem(i, JSON.stringify(setting[i]));
                }
            } else {
                ls.setItem(key, JSON.stringify(val));
            }
        } else {
            Cookie.set(key, val, day);
        }
    },
    remove(key) {
        if (this.hasLocalStorage()) {
            ls.removeItem(key);
        } else {
            Cookie.remove(key);
        }
    },
    clear() {
        ls.clear();
    }
};

export const Session = {
    get(key) {
        if (key) return JSON.parse(ss.getItem(key));
        return null;
    },
    set(key, val) {
        const setting = arguments[0];
        if (Object.prototype.toString.call(setting).slice(8, -1) === "Object") {
            for (const i in setting) {
                ss.setItem(i, JSON.stringify(setting[i]));
            }
        } else {
            ss.setItem(key, JSON.stringify(val));
        }
    },
    remove(key) {
        ss.removeItem(key);
    },
    clear() {
        ss.clear();
    }
};

export const Dom = {
    hasClass(obj, cls) {
        return obj.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
    },
    addClass(obj, cls) {
        if (!this.hasClass(obj, cls)) obj.className += " " + cls;
    },
    toggleClass(obj, cls) {
        if (this.hasClass(obj, cls)) {
            this.removeClass(obj, cls);
        } else {
            this.addClass(obj, cls);
        }
    },
    removeClass(obj, cls) {
        if (this.hasClass(obj, cls)) {
            var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
            obj.className = obj.className.replace(reg, " ");
        }
    }
};

/**
 * @日期格式化，24小时制
 */
export const datefmt = (time = new Date(), fmt = "YYYY-MM-DD hh:mm:ss") => {
    let date = typeof time === "string" ? new Date(time) : time;
    // unicode字符
    let weekdays = [
        "\u65e5",
        "\u4e00",
        "\u4e8c",
        "\u4e09",
        "\u56db",
        "\u4e94",
        "\u516d"
    ];
    let o = {
        "M+": date.getMonth() + 1,
        "D+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S+": date.getMilliseconds(),
        "w+": date.getDay()
    };
    if (/(Y+)/i.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    for (let k in o) {
        // eslint-disable-next-line no-prototype-builtins
        if (o.hasOwnProperty(k)) {
            if (k === "w+") {
                fmt = fmt.replace("w", "\u661f\u671f" + weekdays[o[k]]); // 星期
                // fmt = fmt.replace("w", '\u5468' + weekdays[o[k]]) //周
            } else if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(
                    RegExp.$1,
                    RegExp.$1.length === 1
                        ? o[k]
                        : ("00" + o[k]).substr(("" + o[k]).length)
                );
            }
        }
    }
    return fmt;
};

/**
 * 身份证校验
 */
export const checkIdcard = idCard => {
    if (idCard.slice(17, 18) == "x") {
        idCard = idCard.replace("x", "X");
    }
    idCard = idCard.toString();
    var city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
    };
    var tip = "";
    var pass = true;

    if (
        !idCard ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
            idCard
        )
    ) {
        tip = "身份证号格式错误";
        pass = false;
    } else if (!city[idCard.substr(0, 2)]) {
        tip = "地址编码错误";
        pass = false;
    } else {
        // 18位身份证需要验证最后一位校验位
        if (idCard.length == 18) {
            idCard = idCard.split("");
            // ∑(ai×Wi)(mod 11)
            // 加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            // 校验位
            var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
                ai = idCard[i];
                wi = factor[i];
                sum += ai * wi;
            }
            // var last = parity[sum % 11];
            if (parity[sum % 11] != idCard[17]) {
                tip = "校验位错误";
                pass = false;
            }
        }
    }
    var obj = {
        status: pass,
        msg: tip
    };
    if (!pass) {
        return obj;
    }
    return obj;
};

/**
 * @检查证件合法性
 */
export const checkIdcardValid = (cardtype_id, cardnum) => {
    let result = {};
    result.status = true;
    result.errtips = "";

    if (!cardnum) {
        result.status = false;
        result.errtips = "请输入证件号码";
    } else {
        // 2护照 '/^[a-z0-9]{5,17}$/i'
        // 3港澳通行证、4台湾通行证、5军官证、6士兵证 '/^[a-z0-9]{5,12}$/i'
        /* eslint-disable */
        switch (cardtype_id) {
            case 1:
                if (
                    !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
                        cardnum
                    )
                ) {
                    result.status = false;
                    result.errtips = "身份证格式错误";
                }
                break;
            case 2:
                if (!/^[a-z0-9]{5,17}$/i.test(cardnum)) {
                    result.status = false;
                    result.errtips = "护照格式错误";
                }
                break;
            case 3:
            case 4:
            case 5:
            case 6:
                if (!/^[a-z0-9]{5,12}$/i.test(cardnum)) {
                    result.status = false;
                    result.errtips = "证件格式错误";
                }
                break;
        }
    }
    return result;
};

/**
 * 根据身份证号计算年龄
 */
export const calcIDCard = IDCard => {
    //获取用户身份证号码
    var userCard = IDCard.toString();
    //获取出生年月日
    var yearBirth = parseInt(userCard.substring(6, 10)); //出生年份
    var monthBirth = parseInt(userCard.substring(10, 12)); //出生月份
    var dayBirth = parseInt(userCard.substring(12, 14)); //出生日
    //获取当前年月日并计算年龄
    var myDate = new Date();
    var yearNow = parseInt(myDate.getFullYear()); //当前年份
    var monthNow = parseInt(myDate.getMonth() + 1); //当前月份
    var dayNow = parseInt(myDate.getDate()); //当前日
    var age = yearNow - yearBirth; //
    //
    // 6岁
    if (
        monthNow < monthBirth ||
        (monthNow == monthBirth && dayNow < dayBirth)
    ) {
        age--;
    }

    // 6岁半算作7岁
    // if (monthNow > monthBirth || (monthNow == monthBirth && dayNow > dayBirth)) {
    //   age++;
    // }

    return age;
};

/**
 * 数据脱敏
 */
export const desensitization = val => {
    if (val && val.length) {
        const len = val.length;
        if (len === 1) {
            return "*";
        } else if (len === 2) {
            return val[0] + "*";
        } else if (len === 3) {
            return val[0] + "*" + val[2];
        } else if (len > 3 && len < 6) {
            const newVal = val.substring(1, len - 1);
            let newValChange = [];
            for (let i = 0; i < newVal.length; i++) {
                newValChange.push("*");
            }
            return val[0] + newValChange.join("") + val[len - 1];
        } else if (len >= 6 && len < 8) {
            const newVal = val.substring(2, len - 2);
            let newValChange = [];
            for (let i = 0; i < newVal.length; i++) {
                newValChange.push("*");
            }
            return (
                val[0] +
                val[1] +
                newValChange.join("") +
                val[len - 2] +
                val[len - 1]
            );
        } else {
            const newVal = val.substring(3, len - 3);
            let newValChange = [];
            for (let i = 0; i < newVal.length; i++) {
                newValChange.push("*");
            }
            return (
                val[0] +
                val[1] +
                val[2] +
                newValChange.join("") +
                val[len - 3] +
                val[len - 2] +
                val[len - 1]
            );
        }
    }
};

/**
 * 防止重复点击
 */
let oldtime = "";

export const preventClick = msc => {
    if (oldtime == "") {
        oldtime = new Date().getTime();
        return true;
    } else {
        let newtime = new Date().getTime();
        if (newtime - oldtime > msc) {
            oldtime = new Date().getTime();
            return true;
        } else {
            return false;
        }
    }
};
/**
 * 初始化类型判断方法
 * 在exp对象上新增isNull, isUndefined, isObject, isArray, isString, isNumber, isBoolean, isFunction, isRegExp
 * 可以通过Exp.isUndefined ...这些进行数据格式判断
 */
let exp = {};
let type = o => {
    let s = Object.prototype.toString.call(o);
    return s.match(/\[object (.*?)\]/)[1].toLowerCase();
};

[
    "Null",
    "Undefined",
    "Object",
    "Array",
    "String",
    "Number",
    "Boolean",
    "Function",
    "RegExp"
].forEach(function(t) {
    exp["is" + t] = function(o) {
        return type(o) === t.toLowerCase();
    };
});

export const Exp = exp;

/**
 * 解决遮罩层滚动穿透问题，分别在遮罩层弹出后和关闭前调用
 */
export const ModalHelper = (() => {
    var scrollTop;
    return {
        afterOpen: function() {
            scrollTop = document.scrollingElement.scrollTop;
            document.body.style.position = "fixed";
            document.body.style.width = "100%";
            document.body.style.overflow = "hidden";
            document.body.style.top = -scrollTop + "px";
        },
        beforeClose: function() {
            // scrollTop lost after set position:fixed, restore it back.
            document.body.style.position = "";
            document.body.style.width = "";
            document.body.style.overflow = "";
            document.body.style.top = "";
            document.scrollingElement.scrollTop = scrollTop;
        }
    };
})();

/**
 * @拼接url
 */
export const joinUrl = ({ baseUrl, params }) => {
    let queryArr = [];
    for (let key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key)) {
            let value = params[key];
            if (!value) value = "";
            queryArr.push([key, encodeURIComponent(value)].join("="));
        }
    }
    let url = baseUrl + (queryArr.length ? `?${queryArr.join("&")}` : "");
    return url;
};

/**
 * 验证是否是微信环境
 */
export const checkWx = () => {
    let browser = {
        versions: (function() {
            var u = navigator.userAgent,
                // eslint-disable-next-line no-unused-vars
                app = navigator.appVersion;
            return {
                //移动终端浏览器版本信息
                trident: u.indexOf("Trident") > -1, //IE内核
                presto: u.indexOf("Presto") > -1, //opera内核
                webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
                gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
                iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf("iPad") > -1, //是否iPad
                webApp: u.indexOf("Safari") == -1 //是否web应该程序，没有头部与底部
            };
        })(),
        language: (
            navigator.browserLanguage || navigator.language
        ).toLowerCase()
    };
    if (browser.versions.mobile) {
        var ua = navigator.userAgent.toLowerCase();
        //在微信中打开
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    }
};

/**
 * 判断此对象是否是Object类型
 * @param {Object} obj
 */
export const isObject = obj => {
    return Object.prototype.toString.call(obj) === "[object Object]";
};

/**
 * 判断此类型是否是Array类型
 * @param {Array} arr
 */
export const isArray = arr => {
    return Object.prototype.toString.call(arr) === "[object Array]";
};

/**
 * 深度比较两个对象是否相同
 * @param {Object} oldData
 * @param {Object} newData
 */
export const equalsObj = (oldData, newData) => {
    // 类型为基本类型时,如果相同,则返回true
    if (oldData === newData) return true;
    if (
        isObject(oldData) &&
        isObject(newData) &&
        Object.keys(oldData).length === Object.keys(newData).length
    ) {
        // 类型为对象并且元素个数相同
        // 遍历所有对象中所有属性,判断元素是否相同
        for (const key in oldData) {
            // eslint-disable-next-line no-prototype-builtins
            if (oldData.hasOwnProperty(key)) {
                if (!equalsObj(oldData[key], newData[key]))
                    // 对象中具有不相同属性 返回false
                    return false;
            }
        }
    } else if (
        isArray(oldData) &&
        isArray(oldData) &&
        oldData.length === newData.length
    ) {
        // 类型为数组并且数组长度相同
        for (let i = 0, length = oldData.length; i < length; i++) {
            if (!equalsObj(oldData[i], newData[i]))
                // 如果数组元素中具有不相同元素,返回false
                return false;
        }
    } else {
        // 其它类型,均返回false
        return false;
    }
    // 走到这里,说明数组或者对象中所有元素都相同,返回true
    return true;
};

/**
 * 如果target(也就是obj1[key])存在，
 * 且是对象的话再去调用deepMerge，
 * 否则就是obj1[key]里面没这个对象，需要与obj2[key]合并
 */
export const deepMerge = (obj1, obj2) => {
    let key;
    for (key in obj2) {
        obj1[key] =
            obj1[key] && obj1[key].toString() === "[object Object]"
                ? deepMerge(obj1[key], obj2[key])
                : (obj1[key] = obj2[key]);
    }
    return obj1;
};

export const deepClone = source => {
    const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
    for (let keys in source) {
        // 遍历目标
        // eslint-disable-next-line no-prototype-builtins
        if (source.hasOwnProperty(keys)) {
            if (source[keys] && typeof source[keys] === "object") {
                // 如果值是对象，就递归一下
                targetObj[keys] = source[keys].constructor === Array ? [] : {};
                targetObj[keys] = deepClone(source[keys]);
            } else {
                // 如果不是，就直接赋值
                targetObj[keys] = source[keys];
            }
        }
    }
    return targetObj;
};

/**
 * 多维数组扁平化处理
 */
export const flatten = arr => {
    while (arr.some(item => Array.isArray(item))) {
        arr = [].concat(...arr);
    }
    return arr;
};

/**
 * @解决事件监听兼容性问题
 * @param {Object} obj对象
 * @param {String} type时间类型,不带'on'前缀
 * @param {Function} callback事件处理程序
 */
export const addEvent = (element, type, handler) => {
    if (element.addEventListener) {
        // W3C内核
        element.addEventListener(type, handler, false);
    } else if (element.attachEvent) {
        // IE内核
        element.attachEvent("on" + type, handler);
    } else {
        element["on" + type] = handler;
    }
};

/**
 * 解决移除事件监听兼容性问题
 * @param {Object} obj对象
 * @param {String} type时间类型,不带'on'前缀
 * @param {Function} callback事件处理程序
 */
export const removeEvent = (element, type, handler) => {
    if (element.removeEventListener) {
        // W3C内核
        element.removeEventListener(type, handler);
    } else {
        // IE内核
        element.detachEvent("on" + type, handler);
    }
};

// scrollTop animation
export const scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame =
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
    }
    const difference = Math.abs(from - to);
    const step = Math.ceil((difference / duration) * 50);

    function scroll(start, end, step) {
        if (start === end) {
            endCallback && endCallback();
            return;
        }

        let d = start + step > end ? end : start + step;
        if (start > end) {
            d = start - step < end ? end : start - step;
        }

        if (el === window) {
            window.scrollTo(d, d);
        } else {
            el.scrollTop = d;
        }
        window.requestAnimationFrame(() => scroll(d, end, step));
    }
    scroll(from, to, step);
};

export const getUrlParams = name => {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let search = window.location.href.split("?")[1];
    if (search) {
        let r = search.substr(0).match(reg);
        if (r !== null) {
            return unescape(r[2]);
        }
        return null;
    } else {
        return null;
    }
};



// WEBPACK FOOTER //
// ./src/lib/utils.js